import { gql } from 'apollo-boost'

const MARK_MENU_DEFINITION_TASK_AS_AWAITING = gql`
  mutation markMenuDefinitionTaskAsAwaiting(
    $id: ID!
    $awaitingReason: TaskAwaitingReason!
    $awaitingReasonComment: String
  ) {
    markMenuDefinitionTaskAsAwaiting(
      id: $id
      awaitingReason: $awaitingReason
      awaitingReasonComment: $awaitingReasonComment
    ) {
      isAwaiting
      awaitingReason
      awaitingReasonComment
      modifiedDate
    }
  }
`

export default MARK_MENU_DEFINITION_TASK_AS_AWAITING
